import React, { useState, useEffect, useMemo } from "react";
import { ShieldCheck } from "@phosphor-icons/react";

// Invisible honeypot + a simple math challenge. Reports values up via onChange.
export const AntiSpam = ({ onChange, testid = "antispam" }) => {
  const [a] = useState(() => Math.floor(Math.random() * 8) + 1);
  const [b] = useState(() => Math.floor(Math.random() * 8) + 1);
  const [answer, setAnswer] = useState("");
  const [hp, setHp] = useState("");

  useEffect(() => {
    onChange({ captcha_a: a, captcha_b: b, captcha_answer: answer === "" ? null : Number(answer), hp });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [answer, hp]);

  const solved = useMemo(() => Number(answer) === a + b, [answer, a, b]);

  return (
    <div data-testid={testid}>
      {/* Honeypot — hidden from humans, visible to bots */}
      <div aria-hidden="true" style={{ position: "absolute", left: "-9999px", opacity: 0, height: 0, overflow: "hidden" }}>
        <label>Company Website (leave blank)
          <input tabIndex={-1} autoComplete="off" value={hp} onChange={(e) => setHp(e.target.value)} data-testid={`${testid}-hp`} />
        </label>
      </div>

      <label className="block text-xs font-semibold text-forest mb-2 uppercase tracking-wider">
        Verification <span className="text-gold">*</span>
      </label>
      <div className="flex items-center gap-3">
        <span className="inline-flex items-center gap-2 bg-forest/5 border border-line rounded-sm px-4 py-3 text-forest font-medium select-none">
          <ShieldCheck size={18} className="text-gold" /> What is {a} + {b}?
        </span>
        <input
          type="number"
          value={answer}
          onChange={(e) => setAnswer(e.target.value)}
          placeholder="Answer"
          data-testid={`${testid}-answer`}
          className={`w-28 rounded-sm border bg-white px-4 py-3 text-[15px] text-charcoal focus:outline-none focus:ring-1 focus:ring-gold transition-colors ${
            answer && solved ? "border-gold" : "border-line"
          }`}
        />
      </div>
    </div>
  );
};

export default AntiSpam;
